// extracted by mini-css-extract-plugin
export default {"container":"index-modulecontainer-pJb7T","placeholder":"index-moduleplaceholder-9hf4m"};